const ELEMENT_DELAY_MS = 45;
const MAX_TOTAL_DELAY_MS = 900;

export const AI_MODELING_EFFECT_DURATION_MS = 560;

/** 序盤で一気に詰めて静かに収まるカーブ。持ち上がりの途中でリンクが端点から離れて見える時間が短くなる。 */
export const AI_MODELING_EFFECT_EASING = 'cubic-bezier(0.16, 1, 0.3, 1)';

/** 一度にアニメーションさせる要素数の上限。AIは一度に数百の付箋を作りうるため頭打ちにする。 */
export const AI_MODELING_EFFECT_MAX_ELEMENTS = 400;

/**
 * 要素ごとの遅延。要素が多いときは間隔を詰めて、全体が MAX_TOTAL_DELAY_MS に収まるようにする。
 */
export function calcElementDelayMs(index: number, count: number): number {
  if (count <= 1) return 0;
  const step = Math.min(ELEMENT_DELAY_MS, MAX_TOTAL_DELAY_MS / (count - 1));
  return Math.round(index * step);
}
